import { render } from "./PlayerTagDiscount.vue?vue&type=template&id=8bfb3002&ts=true"
import script from "./PlayerTagDiscount.vue?vue&type=script&lang=ts"
export * from "./PlayerTagDiscount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__